import { render, staticRenderFns } from "./ButtonsGroup.vue?vue&type=template&id=3bd2c88d&"
import script from "./ButtonsGroup.vue?vue&type=script&lang=js&"
export * from "./ButtonsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports